/* Taana Luxe: gentle scroll reveal. Content stays visible if JS or IntersectionObserver is unavailable. */
(function () {
  var root = document.documentElement;
  function showAll(scope) {
    (scope || document).querySelectorAll('[data-tl-reveal]').forEach(function (el) { el.classList.add('tl-in'); });
  }
  if (!root.classList.contains('tl-js')) return;
  if (!('IntersectionObserver' in window)) { showAll(); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('tl-in');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  document.querySelectorAll('[data-tl-reveal]').forEach(function (el) { io.observe(el); });
  window.setTimeout(function () { showAll(); }, 4000);
  document.addEventListener('shopify:section:load', function (event) { showAll(event.target); });
})();